import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { AdvancedNotificationsSmsFailActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function AdvancedNotificationsSmsFail({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as AdvancedNotificationsSmsFailActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return <ItemWrapper notification={notification}>《{formInfo.formName}》短信提醒发送失败</ItemWrapper>
}
